import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Attachment, ICustomer, ILead, IPendingPayment, IPendingPaymentDTO, IResponse, ITicketTopic } from './shared-interface.types';
import { add, reject } from 'lodash';
import { SharedServiceService } from './shared-service.service';
import { WebStorage } from './web.storage';
import { IAddOn } from './interfaces.types';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class SharedMethodsModule {

  private addressStripped: any;
  private searchType: any;

  constructor(
    private _sharedService: SharedServiceService,
    private _webStorage: WebStorage
  ) {

  }

  // ---------------------------------------------------------- //
  // ======================== Customer =========================//
  // ---------------------------------------------------------- //



  public async downloadStatement(statementID: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.downloadStatement(statementID)
        .subscribe({
          next: (statementBlob: any) => {
            resolve({ success: true, result: statementBlob })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }


  public async emailStatement(entityAccountID: number, statementID: number, fromDate: any, toDate: any): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.emailStatement(entityAccountID, statementID, fromDate, toDate)
        .subscribe({
          next: (res: any) => {
            resolve({ success: true, result: res })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getInvoiceById(id: number) {
    return new Promise(resolve => {
      this._sharedService.getInvoiceById(id)
        .subscribe({
          next: (invoice: any) => {
            resolve({ success: true, result: invoice })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getCustomerInvoices() {
    return new Promise(resolve => {
      this._sharedService.getCustomerInvoices()
        .subscribe({
          next: (invoices: any) => {
            resolve({ success: true, result: invoices })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getCustomerOutstandingInvoices() {
    return new Promise(resolve => {
      this._sharedService.getCustomerOutstandingInvoices()
        .subscribe({
          next: (invoices: any) => {
            resolve({ success: true, result: invoices })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getCustomerStatements(entityAccountID: number, status: string): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getCustomerStatements(entityAccountID, status)
        .subscribe({
          next: (statementList: any) => {
            resolve({ success: true, result: statementList })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async updateCustomerAccount(data: any) {
    return new Promise(resolve => {
      this._sharedService.updateCustomerAccount(data)
        .subscribe({
          next: (customer: any) => {
            resolve({ success: true, result: customer })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getCustomerAccount(): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getCustomerAccount()
        .subscribe({
          next: (customer: ICustomer) => {
            resolve({ success: true, result: customer })
          }, error: (err) => {
            resolve({ success: false, error: null })
          }
        })
    })
  }

  public async getCustomerPayments(): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getCustomerPayments()
        .subscribe({
          next: (paymentMethods: any) => {
            resolve({ success: true, result: paymentMethods })
          }, error: (err) => {
            resolve({ success: false, error: null })
          }
        })
    })
  }

  public async getCustomerBillingItems(): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getCustomerBillingItems()
        .subscribe({
          next: (services: any) => {
            resolve({ success: true, result: services })
          }, error: (err) => {
            resolve({ success: false, error: null })
          }
        })
    })
  }

  public async getCustomerLeads(): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getCustomerLeads()
        .subscribe({
          next: (leads: any) => {
            resolve({ success: true, result: leads })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getCustomerActiveServices(): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getCustomerActiveServices()
        .subscribe({
          next: (leads: any) => {
            resolve({ success: true, result: leads })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }




  // ---------------------------------------------------------- //
  // ======================== Debit Order ======================//
  // ---------------------------------------------------------- //

  public async changeDebitOrderDate(account: object): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.changeDebitOrderDate(account)
        .subscribe({
          next: (order: any) => {
            resolve({ success: true, result: order })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getDebitOrderCollectionRuns(): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getDebitOrderCollectionRuns()
        .subscribe({
          next: (collection: any) => {
            resolve({ success: true, result: collection })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }


  ///////////////////
  public async getSalesItemByID(leadEntityID: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getSalesItemByID(leadEntityID)
        .subscribe({
          next: (res: any) => {
            resolve({ success: true, result: res })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }
  ///////////////////

  public async getDebitOrderMandateStatus(leadId: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getDebitOrderMandateStatus(leadId)
        .subscribe({
          next: (order: any) => {
            resolve({ success: true, result: order })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getDebitOrder(LeadEntityID: number) {
    return new Promise(resolve => {
      this._sharedService.getDebitOrder(LeadEntityID)
        .subscribe({
          next: (debitOrder: any) => {
            resolve({ success: true, result: debitOrder })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }


  public async rejectDebitOrderMandate(EntityAccountDebitOrderMandateID: number) {
    return new Promise(resolve => {
      this._sharedService.rejectDebitOrder(EntityAccountDebitOrderMandateID)
        .subscribe({
          next: (debitOrder: any) => {
            resolve({ success: true, result: debitOrder })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async acceptDebitOrderOTP(EntityAccountDebitOrderMandateID: number) {
    return new Promise(resolve => {
      this._sharedService.acceptDebitOrderOTP(EntityAccountDebitOrderMandateID)
        .subscribe({
          next: (debitOrder: any) => {
            resolve({ success: true, result: debitOrder })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async authoriseMandateWithOTP(EntityAccountDebitOrderMandateID: number, OTP: number) {
    return new Promise(resolve => {
      this._sharedService.authoriseMandateWithOTP(EntityAccountDebitOrderMandateID, OTP)
        .subscribe({
          next: (debitOrder: any) => {
            resolve({ success: true, result: debitOrder })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }


  public async generateDebitOrderMandate(leadEntityID: number, entityAccountID: number, debitAmount: number, paymentMethod: any) {
    return new Promise(resolve => {
      this._sharedService.generateDebitOrderMandate(leadEntityID, entityAccountID, debitAmount, paymentMethod)
        .subscribe({
          next: (debitOrderMandateGenerated: any) => {
            resolve({ success: true, result: debitOrderMandateGenerated })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async isDebitOrderRequired(LeadEntityID: number) {
    return new Promise(resolve => {
      this._sharedService.isDebitOrderRequired(LeadEntityID)
        .subscribe({
          next: (doRequired: any) => {
            resolve({ success: true, result: doRequired })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  // ## GETS CURRENT ACTIVE SERVICES ##
  public async getCustomerLeadsArray() {
    const promise = await this.getCustomerLeads().then(async (res) => {
      let response = [];
      for (const element of res?.result.records || []) {
        if (element.LeadStatus !== 'Cancelled' || element.LeadStatus !== 'Expired') {
          switch (element?.LeadActionTypeCode) {
            case "Order":
              const mandateStatus = await this.getDebitOrderMandateStatus(element?.LeadEntityID);
              element["DebitOrderMandateRequired"] = mandateStatus?.result;
              response.push(element);
              break;
            case "PreOrder":
              const mandatePreOrderStatus = await this.getDebitOrderMandateStatus(element?.LeadEntityID);
              element["DebitOrderMandateRequired"] = mandatePreOrderStatus?.result;
              response.push(element);
              break;
            case "ServiceCancellation":
              response.push(element);
              break;
            case "ServiceDowngrade":
              response.push(element);
              break;
            case "ServiceUpgrade":
              response.push(element);
              break;
            case "OrderAddOn":
              response.push(element);
              break;
            case "Interest":
              response.push(element);
              break;
            default:
              break;
          }
        }
      }
      this._sharedService.debitOrdersArray = response;
      return response;
    });
    await Promise.all(promise);
    return promise;
  }

  public async CancelOrder(LeadEntityID: number, reason: any, cancellationComment: any): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.cancelDebitOrder(LeadEntityID, reason, cancellationComment)
        .subscribe({
          next: (cancelResponse: any) => {
            resolve({ success: true, result: cancelResponse })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }




  // ---------------------------------------------------------- //
  // ===================== BANK DETAILS ========================//
  // ---------------------------------------------------------- //
  public async getBankLists(): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getBankList()
        .subscribe({
          next: (banks: any) => {
            resolve({ success: true, result: banks })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getBankAccountTypeList(): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getBankAccountTypeList()
        .subscribe({
          next: (bankAccountTypes: any) => {
            resolve({ success: true, result: bankAccountTypes })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }




  // ---------------------------------------------------------- //
  // ==================== PAYMENT METHODS=======================//
  // ---------------------------------------------------------- //
  public async getUpfrontAmountDue(LeadEntityID: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getUpfrontAmountDue(LeadEntityID)
        .subscribe({
          next: (upfrontAmount: any) => {
            resolve({ success: true, result: upfrontAmount })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getPaymentMethods(): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getPaymentMethods()
        .subscribe({
          next: (paymentMethods: any) => {
            resolve({ success: true, result: paymentMethods })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async addPaymentMethods(paymentMethodDTO: any): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.addPaymentMethods(paymentMethodDTO)
        .subscribe({
          next: (paymentMethodDTO: any) => {
            resolve({ success: true, result: paymentMethodDTO })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async previewDebitOrderMandate(entityAccountDebitOrderMandateID: number, token: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this._sharedService.getDebitOrderMandatePdfBlob(entityAccountDebitOrderMandateID, token).subscribe({
        next: (blob: Blob) => resolve(URL.createObjectURL(blob)),
        error: (err) => reject(err)
      });
    });
  }


  // ---------------------------------------------------------- //
  // ==================== TICKETS=======================//
  // ---------------------------------------------------------- //
  public async getTicketTopics(): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getTicketTopics()
        .subscribe({
          next: (ticketTopic: ITicketTopic) => {
            resolve({ success: true, result: ticketTopic })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  /**
   * Topics for the public Contact Us form: IsPublic only, excluding role-restricted topics.
   */
  public filterContactUsTicketTopics(topics: ITicketTopic[]): ITicketTopic[] {
    if (!Array.isArray(topics)) {
      return [];
    }

    return topics
      .filter((topic) => topic?.IsPublic === true && topic?.RestrictAccess !== true)
      .sort((a, b) => (a.Name ?? '').localeCompare(b.Name ?? ''));
  }

  public async getContactUsTicketTopics(): Promise<IResponse> {
    const response = await this.getTicketTopics();

    if (!response.success) {
      return response;
    }

    return {
      success: true,
      result: this.filterContactUsTicketTopics(response.result),
    };
  }

  public async createContactTicket(ticketData: any): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.createContactTicket(ticketData)
        .subscribe({
          next: (ticketCreated: any) => {
            resolve({ success: true, result: ticketCreated })
          }, error: (err) => {
            reject({ success: false, error: err })
          }
        })
    })
  }

  public async createTicket(ticketData: any): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.createTicket(ticketData)
        .subscribe({
          next: (ticketCreated: any) => {
            resolve({ success: true, result: ticketCreated })
          }, error: (err) => {
            reject({ success: false, error: err })
          }
        })
    })
  }

  public async uploadFileToTicket(ticketID: number, fileObject: any): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.uploadFileToTicket(ticketID, fileObject)
        .subscribe({
          next: (fileUploadedToTicket: any) => {
            resolve({ success: true, result: fileUploadedToTicket })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getAllTickets() {
    return new Promise(resolve => {
      this._sharedService.getAllTickets()
        .subscribe({
          next: (tickets: any) => {
            resolve({ success: true, result: tickets })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getAllTicketMessages(id: string) {
    return new Promise(resolve => {
      this._sharedService.getAllTicketMessages(id)
        .subscribe({
          next: (messages: any) => {
            resolve({ success: true, result: messages })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async sendTicketMessage(ticketNumber: number, message: string) {
    return new Promise(resolve => {
      this._sharedService.sendTicketMessage(ticketNumber, message)
        .subscribe({
          next: (response: any) => {
            resolve({ success: true, result: response })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }



  // ---------------------------------------------------------- //
  // ======================== PACKAGES =========================//
  // ---------------------------------------------------------- //
  public async getAvailablePackages(leadEntityID: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getAvailablePackages(leadEntityID)
        .subscribe({
          next: (packages: any) => {
            resolve({ success: true, result: packages })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getPackageByID(PackageEntityId: number) {
    return new Promise(resolve => {
      this._sharedService.getPackageByID(PackageEntityId)
        .subscribe({
          next: (packageByID: any) => {
            resolve({ success: true, result: packageByID })
            // //console.log("0.0.0" + packageByID)
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getTermsAndConditions(leadEntityID: number, PackageEntityID: number) {
    return new Promise(resolve => {
      this._sharedService.getTermsAndConditions(leadEntityID, PackageEntityID)
        .subscribe({
          next: (terms: any) => {
            resolve({ success: true, result: terms })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async acceptTermsAndConditions(LeadEntityID: number, TermsAndConditionsTemplateID: number) {
    return new Promise(resolve => {
      this._sharedService.acceptTermsAndConditions(LeadEntityID, TermsAndConditionsTemplateID)
        .subscribe({
          next: (acceptedTerm: any) => {
            resolve({ success: true, result: acceptedTerm })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }





  // ---------------------------------------------------------- //
  // ======================== LEADS ============================//
  // ---------------------------------------------------------- //

  public async updateLead(lead: ILead) {
    return new Promise(resolve => {
      this._sharedService.updateLead(lead)
        .subscribe({
          next: (updateLead: any) => {
            resolve({ success: true, result: updateLead })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  /**
   * Converts a lead into an Order. The lead-action-type endpoint is required here: the ordinary
   * lead-update endpoint accepts the payload but does not change the CRM lead type. Upgrades and
   * downgrades keep their own action type.
   */
  public async convertLeadToOrder(LeadEntityID: number): Promise<IResponse> {
    const leadResult = await this.getLeadById(LeadEntityID);
    if (!leadResult?.success) {
      return { success: false, error: leadResult?.error };
    }

    const lead: any = (leadResult.result as any)?.result ?? leadResult.result;
    if (!lead?.LeadEntityID) {
      return { success: false, error: 'Lead not found' };
    }

    if (lead.LeadActionTypeCode === 'Order') {
      return { success: true, result: lead };
    }

    if (lead.LeadActionTypeCode === 'ServiceUpgrade' || lead.LeadActionTypeCode === 'ServiceDowngrade') {
      return { success: true, result: lead };
    }

    return await this.setLeadActionType(LeadEntityID, 'order') as IResponse;
  }

  public async updateLeadStatus(leadEntityID: number, status: string): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.updateLeadStatus(leadEntityID, status)
        .subscribe({
          next: (response: any) => resolve({ success: true, result: response }),
          error: (error: any) => resolve({ success: false, error }),
        });
    });
  }

  public async generateLead(offerableID: number, type: string): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.generateLead(offerableID, type)
        .subscribe({
          next: (packages: any) => {
            resolve({ success: true, result: packages })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async generateAddonLead(offerableID: number, type: string): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.generateAddonLead(offerableID, type)
        .subscribe({
          next: (packages: any) => {
            resolve({ success: true, result: packages })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public removeSalesItemsFromLead(LeadEntityID: number) {
    return new Promise(resolve => {
      this._sharedService.removeSalesItemsFromLead(LeadEntityID)
        .subscribe({
          next: (removed: any) => {
            resolve({ success: true, result: removed })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async addPackageToLead(LeadEntityID: number, Package: any) {
    return new Promise(resolve => {
      this._sharedService.addPackageToLead(LeadEntityID, Package)
        .subscribe({
          next: (addToLead: any) => {
            resolve({ success: true, result: addToLead })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getAddons(LeadAccountEntityID: number) {
    return new Promise(resolve => {
      this._sharedService.getAddons(LeadAccountEntityID)
        .subscribe({
          next: (addons: any) => {
            resolve({ success: true, result: addons })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async addAddOnToLead(addOn: IAddOn) {
    return new Promise(resolve => {
      this._sharedService.addAddOnToLead(addOn)
        .subscribe({
          next: (addOn: any) => {
            resolve({ success: true, result: addOn })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async addItemToLead(leadId: number, OfferableCode: string): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.addItemToLead(leadId, OfferableCode)
        .subscribe({
          next: (result: any) => {
            resolve({ success: true, result: result })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async removeAddOnFromLead(entityLinkedOfferableId: number) {
    return new Promise(resolve => {
      this._sharedService.removeAddOnFromLead(entityLinkedOfferableId)
        .subscribe({
          next: (result: any) => {
            resolve({ success: true, result: result })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async removeSalesItemFromLead(entityLinkedOfferableEntityID: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.removeSalesItemFromLead(entityLinkedOfferableEntityID)
        .subscribe({
          next: (result: any) => {
            resolve({ success: true, result: result })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }


  public async cancelLeadById(LeadEntityID: any) {
    return new Promise(resolve => {
      this._sharedService.cancelLeadById(LeadEntityID)
        .subscribe({
          next: (lead: any) => {
            resolve({ success: true, result: lead })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async cancelLeadWithReason(LeadEntityID: number, cancellationReasonID: number, cancellationNotes: string) {
    return new Promise(resolve => {
      this._sharedService.cancelLeadWithReason(LeadEntityID, cancellationReasonID, cancellationNotes)
        .subscribe({
          next: (lead: any) => {
            resolve({ success: true, result: lead })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async cancelInterestLeadWithoutReason(LeadEntityID: number, cancellationNotes: string) {
    return new Promise(resolve => {
      this._sharedService.cancelInterestLeadWithoutReason(LeadEntityID, cancellationNotes)
        .subscribe({
          next: (lead: any) => {
            resolve({ success: true, result: lead })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getLinkedOfferablesByLeadId(leadEntityID: number) {
    return new Promise(resolve => {
      this._sharedService.getLinkedOfferablesByLeadId(leadEntityID)
        .subscribe({
          next: (linkedOfferables: any) => {
            resolve({ success: true, result: linkedOfferables })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public consumeGoogleAddress(address: any, type: string) {
    let val: any = null;
    if (address.results) {
      this.addressStripped = address.results[0].address_components;
    } else {
      this.addressStripped = address.address_components;
    }

    this.addressStripped?.forEach((a: any) => {
      a.types.forEach((t: any) => {
        if (t == type) {
          val = a.long_name;
          return
        }
      })
    });
    return val
  }

  public async doFeasibility(
    coords?: any,
    address?: any,
    customer?: ICustomer,
    LeadActionTypeCode?: string,
    updatingEntityAccountOfferableId?: number,
    LeadAccountEntityID?: number,
    LeadEntityID?: number
  ): Promise<{ success: boolean, result?: any, error?: any }> {
    try {
      const data = {
        AutoGenerateCollaborators: true,
        Fibre_Feasibility_DoTest: true,
        IsFeasibilityLead: true,
        LeadActionTypeCode: LeadActionTypeCode ?? 'Feasibility',
        LeadBusinessName: '',
        LeadContactEmail: customer?.EmailAddress,
        LeadContactIDNumber: customer?.IDNumber,
        LeadContactName: customer?.FirstName,
        LeadContactSurname: customer?.Surname,
        LeadContactNumber: customer?.MobileNumber,
        LeadCustomerTypeCode: 'Residential',
        LeadDescription: '',
        LeadSource: 'PUBLIC',
        Microwave_Feasibility_DoTest: false,
        Mobile_Feasibility_DoTest: false,
        SiteContactEmail: '',
        SiteContactName: '',
        SiteContactNumber: '',
        Longitude: coords.longitude,
        Latitude: coords.latitude,
        StreetNumber: address ? await this.consumeGoogleAddress(address, 'street_number') : null,
        StreetName: address ? await this.consumeGoogleAddress(address, 'route') : null,
        Suburb: address ? (
          this.consumeGoogleAddress(address, 'sublocality_level_1') ||
          this.consumeGoogleAddress(address, 'sublocality') ||
          this.consumeGoogleAddress(address, 'neighborhood')
        ) : null,
        Town: address ? await this.consumeGoogleAddress(address, 'locality') : null,
        City: address ? await this.consumeGoogleAddress(address, 'administrative_area_level_2') : null,
        Region: address ? await this.consumeGoogleAddress(address, 'administrative_area_level_1') : null,
        Country: address ? await this.consumeGoogleAddress(address, 'country') : null,
        PostalCode: address ? await this.consumeGoogleAddress(address, 'postal_code') : null,
        Address: address ? address.results[0].formatted_address : null,
        UpdatingEntityAccountOfferableID: updatingEntityAccountOfferableId,
        LeadAccountEntityID: LeadAccountEntityID,
        LeadEntityID: LeadEntityID
      };

      return await new Promise((resolve) => {
        this._sharedService.feasability(data).subscribe({
          next: (feasibility: any) => {
            this._webStorage.StoredLead.next(feasibility);
            sessionStorage.setItem('LeadEntityID', feasibility.LeadEntityID);
            resolve({ success: true, result: feasibility });
          },
          error: (err) => {
            sessionStorage.setItem('LeadEntityID', "0");
            resolve({ success: false, error: err });
          }
        });
      });

    } catch (exception) {
      // Catch unexpected issues like coding errors or observable not firing
      return {
        success: false,
        error: {
          message: 'An unexpected error occurred while doing feasibility.',
          details: exception
        }
      };
    }
  }

  public async getLeadById(LeadEntityID: any): Promise<IResponse> {
    return new Promise(async resolve => {
      this._sharedService.getLeadById(LeadEntityID)
        .subscribe({
          next: (lead: any) => {
            resolve({ success: true, result: lead })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getCreditVettingPrevented(LeadEntityID: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getCreditVettingPrevented(LeadEntityID)
        .subscribe({
          next: (result: any) => {
            resolve({ success: true, result: result === true || result?.result === true })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }


  public geoCode(coords?: any, place?: any, customer?: ICustomer) {
    return new Promise(resolve => {
      const geocoder = new window.google.maps.Geocoder()
      if (place) {
        this.searchType = { address: place.formatted_address, }
      } else {
        this.searchType = { location: { lat: coords.latitude ?? coords.lat, lng: coords.longitude ?? coords.long } }
      }
      geocoder.geocode(
        // look at the above if as that depends on the object being used to search
        this.searchType
      ).then(async (response) => {
        const coords = {
          latitude: response.results[0].geometry.location.lat(),
          longitude: response.results[0].geometry.location.lng()
        }

        this._webStorage.SetCustomerCoordinates(coords);
        resolve(await this.doFeasibility(coords, response, customer));
      })
        .catch(err => {

          resolve('Invalid request, please try again!');
        })
    })
  }

  public async setLeadActionType(leadEntityID: number, orderType: string) {
    return new Promise(resolve => {
      this._sharedService.setLeadActionType(leadEntityID, orderType)
        .subscribe({
          next: (orderType: any) => {
            resolve({ success: true, result: orderType })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getLeadMarketingSources(): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getLeadMarketingSources()
        .subscribe({
          next: (reasons: any) => {
            resolve({ success: true, result: reasons })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async updateLeadMarketingSource(LeadEntityID: number, sourceId: number) {
    return new Promise(resolve => {
      this._sharedService.updateLeadMarketingSource(LeadEntityID, sourceId)
        .subscribe({
          next: (lead: any) => {
            resolve({ success: true, result: lead })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  // ---------------------------------------------------------- //
  // ======================== PAYMENTS =========================//
  // ---------------------------------------------------------- //

  public async payNow(data: any): Promise<IResponse> {
    const generatePendingPaymentResults = await this.generatePendingPayment(data);
    const getEntityAccountReceiptsByLeadIdResult = await this.getEntityAccountReceiptsByLeadId(data.leadEntityId);

    // Find and save EntityAccountReceiptID for pending payment matching the LeadEntityID
    if (getEntityAccountReceiptsByLeadIdResult.success && getEntityAccountReceiptsByLeadIdResult.result?.value) {
      const matchingReceipt = getEntityAccountReceiptsByLeadIdResult.result.value.find(
        (receipt: any) => receipt.LeadEntityID === data.leadEntityId && receipt.IsPendingPayment === true
      );
      
      if (matchingReceipt && matchingReceipt.EntityAccountReceiptID) {
        sessionStorage.setItem('EntityAccountReceiptID', matchingReceipt.EntityAccountReceiptID.toString());
      }
    }


    let result = null;

    // Get clean URL without query parameters
    const cleanUrl = window.location.href.split('?')[0];

    if (generatePendingPaymentResults.success) {
      // generate the payment links
      const generatePaymentLinksResult = await this.generatePaymentLinks(generatePendingPaymentResults.result, cleanUrl);
      if (generatePaymentLinksResult.success) {
        result = generatePaymentLinksResult
      }
    }
    else {
      const error = generatePendingPaymentResults.error.error.Message;

      if (error.includes('pending receipts for lead')) {
        // this means there is a pending receipt
        // make that payment
        const getPendingPaymentResult = await this.getPendingPayment(data.leadEntityId);
        if (getPendingPaymentResult.success) {
          const pendingPayment = getPendingPaymentResult.result;
          const generatePaymentLinksResult = await this.generatePaymentLinks(pendingPayment, cleanUrl);
          if (generatePaymentLinksResult.success) {
            result = generatePaymentLinksResult;
          }
        }
      }
    }

    return result
  }

  public async generatePendingPayment(DTO: IPendingPaymentDTO): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.generatePendingPayment(DTO)
        .subscribe({
          next: (pendingPayment: any) => {
            resolve({ success: true, result: pendingPayment })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async generatePaymentLinks(PendingPayment: IPendingPayment, redirectURL: string): Promise<IResponse> {
    // the below inline if is becasue if a new pending payment is created it does not return as an array 
    // if there is a pending receipt in the account
    // returns as array hence the [0]   
    return new Promise(resolve => {
      this._sharedService.generatePaymentLinks(PendingPayment[0] ? PendingPayment[0].EntityAccountReceiptID : PendingPayment.EntityAccountReceiptID, redirectURL)
        .subscribe({
          next: (links: any) => {
            resolve({ success: true, result: links })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getEntityAccountReceiptsByLeadId(leadId: number, top: number = 20, count: boolean = true): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getEntityAccountReceiptsByLeadId(leadId, top, count)
        .subscribe({
          next: (receipts: any) => {
            resolve({ success: true, result: receipts })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async unlinkPendingReceiptFromLead(entityAccountReceiptID: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.unlinkPendingReceiptFromLead(entityAccountReceiptID)
        .subscribe({
          next: (result: any) => {
            resolve({ success: true, result: result })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }


  public async getPendingPayment(DTO: IPendingPaymentDTO): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getPendingPayment(DTO)
        .subscribe({
          next: (pendingPayment: any) => {
            resolve({ success: true, result: pendingPayment })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }



  // ---------------------------------------------------------- //
  // ======================== Services ============================//
  // ---------------------------------------------------------- //
  public async getLeadCancelationReasons(): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getLeadCancelationReasons()
        .subscribe({
          next: (reasons: any) => {
            resolve({ success: true, result: reasons })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getServiceCancelationReasons(): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getServiceCancelationReasons()
        .subscribe({
          next: (reasons: any) => {
            resolve({ success: true, result: reasons })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async cancelService(data: any): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.cancelService(data)
        .subscribe({
          next: (cancelResponse: any) => {
            resolve({ success: true, result: cancelResponse })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }


  // ---------------------------------------------------------- //
  // ======================== Upload Files =====================//
  // ---------------------------------------------------------- //
  public async uploadFile(file: File): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.uploadFile(file)
        .subscribe({
          next: (response: any) => {
            resolve({ success: true, result: response })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async attachment(response: Attachment): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.attachment(response)
        .subscribe({
          next: (response: any) => {
            resolve({ success: true, result: response })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getAllAttachments(entityId: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getAllAttachments(entityId)
        .subscribe({
          next: (response: any) => {
            resolve({ success: true, result: response })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async deleteAttachment(entityAttachmentEntityId: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.deleteAttachment(entityAttachmentEntityId)
        .subscribe({
          next: (response: any) => resolve({ success: true, result: response }),
          error: (err) => resolve({ success: false, error: err })
        });
    });
  }

  // ---------------------------------------------------------- //
  // ======================== CALL ME BACK =====================//
  // ---------------------------------------------------------- //
  public async requestCallBack(leadId: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.requestCallBack(leadId)
        .subscribe({
          next: (response: any) => {
            resolve({ success: true, result: response })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async requestCallBackLead(lead: ILead): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.requestCallBackLead(lead)
        .subscribe({
          next: (response: any) => {
            resolve({ success: true, result: response })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  // Creates a new Callback lead when there is no lead in session yet (e.g. the user
  // lands on /packages from cache or the feasibility call failed and stored "0").
  // LeadEntityID is deliberately omitted so Agility's POST /lead upsert creates.
  public async createCallbackLead(
    contact: { LeadContactName: string, LeadContactSurname: string, LeadContactEmail: string, LeadContactNumber: string },
    coords?: any,
    address?: any
  ): Promise<IResponse> {
    const dto: any = {
      AutoGenerateCollaborators: true,
      IsFeasibilityLead: false,
      LeadActionTypeCode: 'Callback',
      // LeadCustomerTypeCode is deliberately omitted — the modal never asks, so we
      // leave it null rather than assume. The agent sets it on the callback.
      LeadSource: 'PUBLIC',
      LeadDescription: 'Callback requested from packages page',
      LeadContactName: contact.LeadContactName,
      LeadContactSurname: contact.LeadContactSurname,
      LeadContactEmail: contact.LeadContactEmail,
      LeadContactNumber: contact.LeadContactNumber,
      Latitude: coords?.latitude ?? null,
      Longitude: coords?.longitude ?? null,
      StreetNumber: address ? this.consumeGoogleAddress(address, 'street_number') : null,
      StreetName: address ? this.consumeGoogleAddress(address, 'route') : null,
      Suburb: address ? this.consumeGoogleAddress(address, 'sublocality_level_1') : null,
      Town: address ? this.consumeGoogleAddress(address, 'locality') : null,
      City: address ? this.consumeGoogleAddress(address, 'administrative_area_level_2') : null,
      Region: address ? this.consumeGoogleAddress(address, 'administrative_area_level_1') : null,
      Country: address ? this.consumeGoogleAddress(address, 'country') : null,
      PostalCode: address ? this.consumeGoogleAddress(address, 'postal_code') : null,
      Address: address?.results?.[0]?.formatted_address ?? address?.formatted_address ?? null
    };

    return new Promise(resolve => {
      this._sharedService.createCallbackLead(dto)
        .subscribe({
          next: (response: any) => {
            resolve({ success: true, result: response })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }


  // ---------------------------------------------------------- //
  // ====================Special Product========================//
  // ---------------------------------------------------------- //

  public async getSpecialProduct(EntityAccountOfferableEntityID: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getSpecialProduct(EntityAccountOfferableEntityID)
        .subscribe({
          next: (specialProduct: any) => {
            resolve({ success: true, result: specialProduct })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async packageCompletionValidate(leadEntityID: number) {
    return new Promise(resolve => {
      this._sharedService.packageCompletionValidate(leadEntityID)
        .subscribe({
          next: (packageValidated: any) => {
            resolve({ success: true, result: packageValidated })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async executeSpecialProductAction(leadEntityID: number, salesEntityId: number, actionKey: string, actionPayload: any) {
    return new Promise(resolve => {
      this._sharedService.executeSpecialProductAction(leadEntityID, salesEntityId, actionKey, actionPayload)
        .subscribe({
          next: (specialProduct: any) => {
            resolve({ success: true, result: specialProduct })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getSpecialProductOverview(leadEntityID: number, salesEntityId: number) {
    return new Promise(resolve => {
      this._sharedService.getSpecialProductOverview(leadEntityID, salesEntityId)
        .subscribe({
          next: (specialProduct: any) => {
            resolve({ success: true, result: specialProduct })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async specialProductAction(leadEntityID: number, packageEntityID: number) {
    return new Promise(resolve => {
      this._sharedService.getSpecialProductOverview(leadEntityID, packageEntityID)
        .subscribe({
          next: (specialProduct: any) => {
            resolve({ success: true, result: specialProduct })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async executeSpecialProductSubActionService(salesEntityId: number, actionKey: string, subActionKey: string, actionPayload: any) {
    return new Promise(resolve => {
      this._sharedService.executeSpecialProductSubActionService(salesEntityId, actionKey, subActionKey, actionPayload)
        .subscribe({
          next: (subActionExecuted: any) => {
            resolve({ success: true, result: subActionExecuted })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async executeSpecialProductSubAction(leadEntityID: number, salesEntityId: number, actionKey: string, subActionKey: string, actionPayload: any) {
    return new Promise(resolve => {
      this._sharedService.executeSpecialProductSubAction(leadEntityID, salesEntityId, actionKey, subActionKey, actionPayload)
        .subscribe({
          next: (subActionExecuted: any) => {
            resolve({ success: true, result: subActionExecuted })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getSpecialProductOverviewOnService(entityAccountOfferableEntityID: number) {
    return new Promise(resolve => {
      this._sharedService.getSpecialProductOverviewOnService(entityAccountOfferableEntityID)
        .subscribe({
          next: (specialProduct: any) => {
            resolve({ success: true, result: specialProduct })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async executeSpecialProduct(entityAccountOfferableEntityID: number, actionKey: string) {
    return new Promise(resolve => {
      this._sharedService.executeSpecialProduct(entityAccountOfferableEntityID, actionKey)
        .subscribe({
          next: (specialProduct: any) => {
            resolve({ success: true, result: specialProduct })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }


  public async requiresAddressVerification(leadEntityID: number) {
    return new Promise(resolve => {
      this._sharedService.requiresAddressVerification(leadEntityID)
        .subscribe({
          next: (requiresVerification: any) => {
            resolve({ success: true, result: requiresVerification })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getAddressVerification(leadEntityID: number, address: string) {
    return new Promise(resolve => {
      this._sharedService.getAddressVerification(leadEntityID, address)
        .subscribe({
          next: (addressVerification: any) => {
            resolve({ success: true, result: addressVerification })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getChannelPartnerOrder(LeadEntityID: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getChannelPartnerOrder(LeadEntityID)
        .subscribe({
          next: (response: any) => {
            resolve({ success: true, result: response })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async createChannelPartnerOrder(
    LeadEntityID: number,
    emailVerificationToken: string,
    emailVerified: boolean,
    leadRegistrationToken: string,
    passwordReset: boolean,
    passwordResetToken: string,
    userName: string): Promise<IResponse> {

    return new Promise(resolve => {
      this._sharedService.createChannelPartnerOrder(LeadEntityID, emailVerificationToken, emailVerified, leadRegistrationToken, passwordReset, passwordResetToken, userName)
        .subscribe({
          next: (response: any) => {
            resolve({ success: true, result: response })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async channelPartnerOrder(leadID: number, detailsUpdated: boolean) {
    return new Promise(resolve => {
      this._sharedService.channelPartnerOrder(leadID, detailsUpdated)
        .subscribe({
          next: (channelPartnerOrder: any) => {
            resolve({ success: true, result: channelPartnerOrder })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async creditVetting(lead: ILead) {
    return new Promise(resolve => {
      this._sharedService.creditVetting(lead)
        .subscribe({
          next: (creditVetting: any) => {
            resolve({ success: true, result: creditVetting })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

public async validateAccountForVetting(accountID: number) {
    return new Promise(resolve => {
      this._sharedService.validateAccountForVetting(accountID)
        .subscribe({
          next: (result: any) => {
            resolve({ success: true, result: result })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }


  
  /* -------------------------------------------------------------------------- */
  /*                              Duplicate Orders                              */
  /* -------------------------------------------------------------------------- */

  public async checkForDuplicateOrderById(LeadEntityID: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.checkForDuplicateOrderById(LeadEntityID)
        .subscribe({
          next: (res: any) => {
            resolve({ success: true, result: res })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async checkCustomerDuplicateOrderById(LeadEntityID: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.checkCustomerDuplicateOrderById(LeadEntityID)
        .subscribe({
          next: (res: any) => {
            resolve({ success: true, result: res })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getDuplicateOrderReasons(LeadEntityID: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getDuplicateOrderReasons(LeadEntityID)
        .subscribe({
          next: (res: any) => {
            resolve({ success: true, result: res })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async updateDuplicateOrderReason(LeadEntityID: number, duplicateOrderNotes: string, duplicateOrderReasonID: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.updateDuplicateOrderReason(LeadEntityID, duplicateOrderNotes, duplicateOrderReasonID)
        .subscribe({
          next: (res: any) => {
            resolve({ success: true, result: res })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }


  /* -------------------------------------------------------------------------- */
  /*                                   Quotes                                   */
  /* -------------------------------------------------------------------------- */

  /* ------------------------------- Get Quotes ------------------------------- */
  public async getQuotes(LeadEntityID: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getQuotes(LeadEntityID)
        .subscribe({
          next: (res: any) => {
            resolve({ success: true, result: res })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  /* ------------------------------- Email Quote ------------------------------ */
  public async emailQuote(LeadEntityID: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.emailQuote(LeadEntityID)
        .subscribe({
          next: (res: any) => {
            resolve({ success: true, result: res })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  /* -------------------------- Get Quote (Download) -------------------------- */
  public async downloadQuote(QuoteID: string): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.downloadQuote(QuoteID)
        .subscribe({
          next: (res: any) => {
            resolve({ success: true, result: res })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  /* --------------------------- Upload Signed Quote -------------------------- */
  public async uploadSignedQuote(
    leadEntityID: number,
    contractSignedDate: string,
    signedContractFileName: string,
    signedContractFileID: number
  ): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.uploadSignedQuote(
        leadEntityID,
        contractSignedDate,
        signedContractFileName,
        signedContractFileID
      )
        .subscribe({
          next: (res: any) => {
            resolve({ success: true, result: res })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  /* ------------------------ Download Signed Contract ------------------------ */
  public async downloadSignedQuote(leadEntityID: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.downloadSignedQuote(leadEntityID)
        .subscribe({
          next: (res: any) => {
            resolve({ success: true, result: res })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  /* ------------------------------ Accept Quote ------------------------------ */
  public async acceptQuote(leadEntityID: number, quoteId: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.acceptQuote(leadEntityID, quoteId)
        .subscribe({
          next: (res: any) => {
            resolve({ success: true, result: res })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  /* ------------------------------ Reject Quote ------------------------------ */
  public async rejectQuote(leadEntityID: number, quoteId: string): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.rejectQuote(leadEntityID, quoteId)
        .subscribe({
          next: (res: any) => {
            resolve({ success: true, result: res })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }


  /* ------------------------------ Pending Services ------------------------------ */


  public async getPendingServices(billingId: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getPendingServices(billingId)
        .subscribe({
          next: (res: any) => {
            resolve({ success: true, result: res })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async cancelServiceRenewal(serviceId: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.cancelServiceRenewal(serviceId)
        .subscribe({
          next: (response: any) => {
            resolve({ success: true, result: response })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

}
